/**
 * DateRangeSelector — three-pill selector: Today / Last 7d / Last 30d.
 *
 * Controlled component. `value` is one of "today" | "7d" | "30d".
 * onChange fires with the new value.
 */
import React from "react";
import { cn } from "@/lib/utils";

const RANGES = [
  { key: "today", label: "Today" },
  { key: "7d", label: "Last 7d" },
  { key: "30d", label: "Last 30d" },
];

export default function DateRangeSelector({ value, onChange }) {
  return (
    <div
      className="inline-flex items-center gap-1 rounded-full p-1"
      style={{
        background: "var(--pp-surface-2)",
        border: "1px solid var(--pp-border)",
      }}
      data-testid="analytics-daterange-selector"
      role="tablist"
    >
      {RANGES.map((r) => {
        const active = value === r.key;
        return (
          <button
            key={r.key}
            type="button"
            role="tab"
            aria-selected={active}
            className={cn(
              "rounded-full px-4 py-1.5 text-sm font-medium transition-colors",
              "focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1",
            )}
            style={{
              background: active ? "var(--pp-orange)" : "transparent",
              color: active ? "var(--pp-cta-text)" : "var(--pp-text-soft)",
            }}
            onClick={() => onChange(r.key)}
            data-testid={`analytics-daterange-${r.key}`}
            data-active={active ? "true" : "false"}
          >
            {r.label}
          </button>
        );
      })}
    </div>
  );
}
